import { Trans } from 'react-i18next'
import { Button, GenericDialog } from '@/common'
import { ImportedGood, useDeleteImportedGood } from '@/features/cbam-reporting/hooks/importedGoods'
import useI18n from '@/shared/hooks/usei18n'
import { useCallback } from 'react'
import toast from 'react-hot-toast'

export default function ImportedGoodDeleteDialog({
  isOpen,
  close,
  organizationId,
  importedGood
}: {
  isOpen: boolean
  close: () => void
  organizationId: string
  importedGood: ImportedGood
}) {
  const { t } = useI18n()
  const { mutateAsync: deleteImportedGood, isPending: isDeleting } = useDeleteImportedGood(
    organizationId,
    importedGood.id
  )
  const name = importedGood.description || importedGood.cnCode

  const onDeleteClick = useCallback(async () => {
    try {
      await deleteImportedGood()
      toast.success(
        t('cbamReporting:cbamReportDetails.importedGoodDeleteDialog.notifications.success')
      )
      close()
    } catch (error) {
      console.error(error)
      toast.error(t('cbamReporting:cbamReportDetails.importedGoodDeleteDialog.notifications.error'))
    }
  }, [deleteImportedGood, close, t])

  return (
    <GenericDialog
      isOpen={isOpen}
      close={close}
      title={t('cbamReporting:cbamReportDetails.importedGoodDeleteDialog.title')}
      size="md"
    >
      <div className="space-y-4">
        <p>
          <Trans
            i18nKey="cbamReporting:cbamReportDetails.importedGoodDeleteDialog.description"
            values={{ name }}
            components={{ strong: <strong /> }}
          />
        </p>
        <footer className="gap-2 flex justify-end">
          <Button variant="neutral" onClick={close}>
            {t('common:actions.cancel')}
          </Button>
          <Button variant="danger" onClick={onDeleteClick} isLoading={isDeleting}>
            {t('common:actions.delete')}
          </Button>
        </footer>
      </div>
    </GenericDialog>
  )
}
